// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"786":"4bd0e418","844":"711f837d"}[chunkId] + ".chunk.css";
};